<template>
  <AppTabs :items="projectTabs" :default-index="selectedIndex"  />
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
import AppTabs, { TabItem } from '@/components/app/AppTabs.vue'
import { Project } from '@/models/project'

const props = defineProps({
  project: {
    type: Object as PropType<Project>,
    required: true
  }
})

const projectTabs = computed((): TabItem[] => [
  { label: 'Overview', to: { name: 'ShowProject', params: { customerId: props.project.customerId, projectId: props.project.id } } },
  { label: 'Budget & Track', to: { name: 'ShowBudget', params: { id: props.project.id  } } },
  { label: 'Proposal & Change Orders', to: { name: 'ShowProposal', params: { id: props.project.id } } },
  { label: 'Schedule', to: { name: 'Scheduling', params: { customerId: props.project.customerId, projectId: props.project.id } } },
  { label: 'Expenses', to: { name: 'ListProjectExpenses', params: { customerId: props.project.customerId, projectId: props.project.id } } },
  { label: 'Invoices', to: { name: 'ListProjectIncome', params: { customerId: props.project.customerId, projectId: props.project.id } } }
])

const router = useRouter()
const selectedIndex = computed(() => {
  const index = projectTabs.value.findIndex(tab => {
    if (router.resolve(tab.to).path === router.currentRoute.value.path) {
      return true
    } else {
      if (router.currentRoute.value.name === 'CreateBudget') {
        return tab.label === 'Budget & Track'
      } else if (router.currentRoute.value.name === 'CreateProposal' || router.currentRoute.value.name === 'EditProposal' || router.currentRoute.value.name === 'EditChangeOrder') {
        return tab.label === 'Proposal & Change Orders'
      }
    }
  })
  return index === -1 ? 0 : index
})
</script>
